import React, { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { TipoUsuario } from '../../types';
import Sidebar from './Sidebar';
import Header from './Header';
import Breadcrumb from '../Common/Breadcrumb';

const Layout: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-4 text-neutral-600 font-medium">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (
    user?.tipo === TipoUsuario.FuncionarioEstabelecimento &&
    !pathname.startsWith('/pdv') &&
    pathname !== '/perfil'
  ) {
    return <Navigate to="/pdv" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 to-neutral-100">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Header onMenuClick={() => setSidebarOpen(true)} />

      {/* Backdrop overlay para mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-30 lg:hidden transition-opacity"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <main className="lg:ml-64 mt-16 p-6 md:p-8">
        <Breadcrumb />
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
